<!-- Already uploaded -->
<template>
  <div :class="!isSent ? 'files--not-sent' : 'files--done'" v-if="files && files.length">
    <div v-if="isSent" class="uploaded-description">
      <p class="uploaded-description__text">
        Data wysłania:
        <span class="uploaded-description__text-decorator">
          {{ formatDate(sentAt, true) }}
        </span>
      </p>
    </div>
    <transition-group name="fade-animation" mode="out-in" class="uploader-files-wrapper">
      <slot></slot>
      <div v-for="file in sortedFiles" :key="file.id" class="uploader-form-file" :class="{ 'inactive': isOfficeLogin }">
        <div class="uploader-form-file__content">
          <div class="uploader-form-file__wrapper">
            <img class="uploader-form-file__icon" alt="" aria-hidden="true"
              src="@/assets/images/icons/i_homework-file.svg" />
            <div class="flex flex-col">
              <span class="uploader-form-file__name">{{ file.name }}</span>
              <div class="uploader-form-file__date">
                {{ formatDate(file.sent_at || file.uploaded_at) }} | {{ convertBytesToMb(file.size) }} MB
              </div>
            </div>
          </div>
        </div>
        <div class="flex self-start">
          <div v-if="!file.sent_at" class="uploader-form-file__status --ctrl">
            <div class="failed-status">
              <button @click="removeFile(file.student_id, file.homework_id, file.id)">
                <img src="@/assets/images/icons/i_homework-close.svg" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    files: {
      type: Array,
    },
    isSent: {
      type: Boolean,
    },
    sentAt: {
      type: String,
    }
  },

  computed: {
    ...mapGetters('auth', ['isOfficeLogin']),
    sortedFiles() {
      return this.files
        .sort((a, b) => new Date(a.uploaded_at) - new Date(b.uploaded_at))
        .reverse();
    },
    sumFiles() {
      return this.files.length !== 0
        ? this.files
          .filter(file => !file.is_deleted && !file.sent_at)
          .map(file => +file.size)
          .reduce((total, amount) => total + amount, 0)
        : 0;
    }
  },

  methods: {
    ...mapActions("uploadedHomeworks", ["removeUploadedHomework"]),

    formatDate(date, asTitle = false) {
      if (asTitle) {
        return moment(date).format("DD.MM.YYYY HH:mm")
      }
      return moment(date).format("HH:mm | DD.MM.YYYY");
    },

    handleUploadProgress(e) {
      this.progress = Math.round((e.loaded * 100) / e.total);
    },

    convertBytesToMb(sizeInBytes) {
      const sizeInMb = sizeInBytes / (1024 * 1024);

      return sizeInMb.toFixed(1);
    },
    
    async removeFile(student_id, homework_id, id) {
      await this.removeUploadedHomework({
        student_id: student_id,
        homework_id: homework_id,
        file_id: id,
      });
    },
  },

  updated() {
    this.$emit("uploaded-sizes", this.sumFiles);
  },
};
</script>

<style lang="scss" scoped>
.files--done,
.files--not-sent {
  background-color: #FAFAFC;
  border: 1px solid #F3F5F8;
  border-radius: 8px;
  padding: 18px;

  @media screen and (min-width: 1280px) {
    padding: 32px;
  }

  .uploader-form-file__status.--txt {
    display: none;
  }

  .uploader-form-file__status.--ctrl {
    padding-left: 54px;
  }
}

.uploaded-description {
  margin-bottom: 24px;

  &__text {
    color: #5B657A;
    font-family: "GT Walsheim Pro";
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
  }

  &__text-decorator {
    color: #111724;
  }
}

.uploader-files-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 24px;
  width: 100%;

  @media screen and (min-width: 1280px) {
    grid-template-columns: 1fr 1fr;
  }
}

.uploader-form-file {
  position: relative;
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  border-radius: 8px;
  border: 1px solid #E7E9EE;
  background: #FFF;

  @media screen and (min-width: 1280px) {
    max-width: 440px;
  }

  &.inactive {
    display: none;
  }

  @media screen and (min-width: 340px) {
    @apply flex-row items-center;
  }

  &__content {
    @apply flex flex-col justify-between text-black leading-tight;
  }

  &__wrapper {
    display: flex;
    gap: 12px;
  }

  &__name {
    color: #111724;
    text-overflow: ellipsis;
    font-family: "GT Walsheim Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    max-width: 150px;
    display: block;
    overflow: hidden;
    white-space: nowrap;
  }

  &__icon {
    width: 20px;
    height: 20px;
    align-items: flex-start;
  }

  &__date {
    color: #5B657A;
    font-family: "GT Walsheim Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    margin-top: 12px;
    white-space: nowrap;
    /* 128.571% */
  }

  &__size {
    color: #5B657A;
    font-family: "GT Walsheim Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    margin-top: 12px;
    white-space: nowrap;
  }

  &__status {
    position: absolute;
    top: 16px;
    right: 16px;

    @apply flex w-full justify-end items-center font-bold text-green-light text-sm pl-2;

    @media screen and (min-width: 340px) {
      width: auto;
    }

    .failed-status {
      button {
        @apply flex justify-center items-center outline-none;
        cursor: pointer;
        gap: 4px;
        color: #2E384A;
        font-family: "GT Walsheim Pro";
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        white-space: nowrap;
        transition: 0.3s;

        &:hover {
          color: #E10A7B;
        }
      }
    }
  }
}

.fade-animation-enter-active {
  transition: all 0.4s ease;
}

.fade-animation-leave-active {
  transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}

.fade-animation-enter,
.fade-animation-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
</style>
